export default __webpack_public_path__ + "static/media/expressjs.c4364081.svg";